import { EditorState, Transaction } from 'prosemirror-state';
import { RichTextMenuButtonType } from '@nimbus-library/features/shared/components/material/input-rich-text/models/rich-text-menu-button-type.model';

export const IndentCommand = (type: RichTextMenuButtonType, state: EditorState, dispatch?: (tr: Transaction) => void): void => {
  if (type !== RichTextMenuButtonType.Indent && type !== RichTextMenuButtonType.Outdent) {
    return;
  }

  const { selection, tr } = state;
  state.doc.nodesBetween(selection.from, selection.to, (node, pos) => {
    if (node.type.name === 'paragraph') {
      const level = node.attrs['level'] || 0;
      const newLevel = type === RichTextMenuButtonType.Indent ? level + 1 : Math.max(level - 1, 0);
      tr.setNodeMarkup(pos, undefined, { ...node.attrs, level: newLevel });
    }
  });
  dispatch(tr);
};
